import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import "./auth.scss";
import {
  emailValidation,
  noSpaceOnChange,
  phoneValidation,
} from "../../validations/validation";

import { forgotPassword } from "../../service/api/user/forgotPassword";
import InputField from "../../jsx/components/fields/inputField";
import { validateSecurityCode } from "../../service/api/user/validateSecurityCode";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { activateUser } from "../../service/api/user/activationCode";
import { resendCode } from "../../service/api/user/resendActivationCode";
import { verifySecurityCodeApi } from "../../service/api/user/verifySecurityCode";
const VerifyComponent = ({ hanldleChangeMyMailOrPhone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loaderActive, setLoaderActive] = useState(false);

  const [recievedCodeValue, setRecievedCodeValue] = useState("");
  const [isCodeError, setIsCodeError] = useState(false);
  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [resendCodeTimer, setResendCodeTimer] = useState(60);
  const [resendCodeCheck, setResendCodeCheck] = useState(true);

  const intervalId = useRef(null);

  useEffect(() => {
    if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
      setIsPhone(false);
    } else if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
      setIsPhone(true);
    }
    if (resendCodeCheck && resendCodeTimer > 0) {
      intervalId.current = setInterval(
        () => setResendCodeTimer((prev) => prev - 1),
        1000
      );
    } else if (!resendCodeCheck || resendCodeTimer === 0) {
      clearInterval(intervalId.current);
    }

    if (resendCodeTimer === 0) {
      setResendCodeCheck(false);
    }
    return () => clearInterval(intervalId.current);
  }, [resendCodeCheck, resendCodeTimer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaderActive(true);
    if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append(
        "phone_code_id_int",
        parseInt(localStorage.getItem("countryCodeVal"))
      );
      formData.append(
        "phone_number_int",
        parseInt(localStorage.getItem("emailPhoneVal"))
      );
      formData.append("email_chr", "");
      formData.append("security_code_chr", otp);

      dispatch(
        verifySecurityCodeApi(
          formData,
          (res) => {
            setOtp("");
            localStorage.setItem("security_code_chr",res.data.data.security_code_chr)
            navigate("/login");
            setLoaderActive(false);
          },
          (err) => {
            setLoaderActive(false);
            setIsCodeError(true);
          }
        )
      );
    } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append("phone_code_id_int", 0);
      formData.append("phone_number_int", 0);
      formData.append("email_chr", localStorage.getItem("emailPhoneVal"));
      formData.append("security_code_chr", otp);

      dispatch(
        verifySecurityCodeApi(
          formData,
          (res) => {
            setOtp("");
            localStorage.setItem("security_code_chr",res.data.data.security_code_chr)
            navigate("/login");
            setLoaderActive(false);
          },
          (err) => {
            setLoaderActive(false);
            setIsCodeError(true);
          }
        )
      );
    }
  };

  function handleMoveToSignUp() {
    navigate("/login", { replace: true });
  }

  function handleValidateCode(e) {
    setIsCodeError(false);
    setRecievedCodeValue(e.target.value);
  }

  const resendCodeActivation = () => {
    if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append(
        "phone_code_id_int",
        parseInt(localStorage.getItem("countryCodeVal"))
      );
      formData.append(
        "phone_number_int",
        parseInt(localStorage.getItem("emailPhoneVal"))
      );
      formData.append("email_chr", "");

      dispatch(
        resendCode(
          formData,
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("success");
            setHandleToaster(true);

            setResendCodeCheck(true);
            setResendCodeTimer(60);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          },
          (err) => {
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append("phone_code_id_int", 0);
      formData.append("phone_number_int", 0);
      formData.append("email_chr", localStorage.getItem("emailPhoneVal"));

      dispatch(
        resendCode(
          formData,
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("success");
            setHandleToaster(true);

            setResendCodeCheck(true);
            setResendCodeTimer(60);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          },
          (err) => {
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  };
  const [otp, setOtp] = useState("");

  return (
    <>
      <div>
        <div className="row" >
          <p className="login-title">Enter verification code we sent to</p>
        </div>
        <div className="row">
          <p className="login-text-heading">
            {localStorage.getItem("emailPhoneVal")}
          </p>
        </div>

        <div className="row">
          {" "}
          <p
            className="login-subtitle"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={hanldleChangeMyMailOrPhone}>
            {isPhone ? "Change number?" : "Change email?"}
          </p>
        </div>

        <div className="row">
          <form onSubmit={handleSubmit}>
            <div className=" mb-4 mt-3 d-flex justify-content-center">
              <OtpInput
                inputStyle={{
                  width: "2rem",
                  height: "2rem",
                  display: "flex",
                  justifyContent: "center",
                }}
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span>-</span>}
                inputType="tel"
                shouldAutoFocus
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <PrimaryButton
              buttonName={"Submit"}
              type={"submit"}
              isLoading={loaderActive}
              loadingMessage={"Validating..."}
              style={{ width: "100%" }}
            />
          </form>
        </div>
        <div className="row mt-5 mb-3 text-center">
          <span>
            {" "}
            Didn't receive the code? You can request a new code <br></br>to be
            sent in 00:
            {resendCodeTimer > 9 ? resendCodeTimer : "0" + resendCodeTimer}{" "}
          </span>
        </div>
        <div className=" d-flex justify-content-center">
          <span
            onClick={resendCodeActivation}
            style={{
              color: "orange",
              fontWeight: "700",
              pointerEvents: resendCodeCheck ? "none" : "auto",
              opacity: resendCodeCheck ? "0.5" : "1",
              cursor: "pointer",
            }}>
            Resend now
          </span>
        </div>
      </div>

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
    </>
  );
};

export default VerifyComponent;
